import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=4e548f09&scoped=true&"
import script from "./Conversation.vue?vue&type=script&lang=ts&"
export * from "./Conversation.vue?vue&type=script&lang=ts&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=4e548f09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e548f09",
  null
  
)

export default component.exports